module.exports = __webpack_public_path__ + "static/media/rajecke3.2eb93556.jpeg";